import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"
import { z } from "zod/v4"

import { INVOICE_TABS } from "@atlant/agent-contract"

import { queryKeys } from "#lib/query-keys.ts"
import { InvoiceUploadListDocument } from "#pages/authenticated/invoices/anomaly/upload-queue.tsx"
import { InvoiceLateListDocument } from "#pages/authenticated/invoices/late/late-invoices.tsx"
import { InvoiceMonthSummariesDocument } from "#pages/authenticated/invoices/page.tsx"
import { client } from "#utils/graphql-client.ts"

const searchSchema = z.object({
  aircraftId: z.string().optional(),
  year: z.coerce.number().int().min(2000).max(2100).catch(new Date().getFullYear()),
  tab: z.enum(INVOICE_TABS).catch("all"),
})

export const Route = createFileRoute("/_authenticated/$slug/invoices/")({
  validateSearch: searchSchema,
  loaderDeps: ({ search: { aircraftId, year, tab } }) => ({ aircraftId, year, tab }),
  loader: async ({
    context: { queryClient, userInfo },
    deps: { aircraftId, year, tab },
  }) => {
    if (userInfo.state !== "LoggedIn") return

    const organizationId = userInfo.me.organization.id
    await Promise.all([
      queryClient.ensureQueryData({
        queryKey: queryKeys.invoices.monthSummaries(organizationId, aircraftId, year),
        queryFn: () =>
          client.request(InvoiceMonthSummariesDocument, {
            input: { organizationId, aircraftId, year },
          }),
      }),
      tab === "late" &&
        queryClient.ensureQueryData({
          queryKey: queryKeys.invoices.lateList(organizationId, aircraftId, year),
          queryFn: () =>
            client.request(InvoiceLateListDocument, {
              input: { organizationId, aircraftId, year },
            }),
        }),
      tab === "anomaly" &&
        queryClient.ensureQueryData({
          queryKey: queryKeys.invoices.uploads(organizationId),
          queryFn: () =>
            client.request(InvoiceUploadListDocument, { input: { organizationId } }),
        }),
    ])
  },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/invoices/page.tsx"),
    "Invoices",
  ),
})
